import { useModalContext } from '../context/modalContext.jsx';
import React from 'react';
import { Information } from '../components/Modals';

export default function useInfoModal() {
  const [showModal] = useModalContext();
  return React.useCallback(
    ({ title, description }) =>
      (e) => {
        e.preventDefault();
        showModal(<Information title={title} description={[description]} />);
      },
    [showModal],
  );
}
